const I18N = {
  namespaces: ['common', 'pages'],
  defaultNamespace: 'common',
};

export default I18N;
